module.exports = __webpack_public_path__ + "static/media/day_profile_background.d3795fe5.jpg";